import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./game.css";
import Swal from "sweetalert2";
import { updateScore, getScore } from "../../scoreservice";

function Game({ updateHeader }) {
  const navigate = useNavigate();

  const [themeData, setThemeData] = useState(null);
  const [points, setPoints] = useState(0);
  const [wrongCount, setWrongCount] = useState(0);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [gameComplete, setGameComplete] = useState(false);

  console.log(themeData);

  // Bin Toss data from theme
  const [allImages, setAllImages] = useState([]);
  const [filteredIcons, setFilteredIcons] = useState([]);
  const [currentBatch, setCurrentBatch] = useState([]);
  const [remainingImages, setRemainingImages] = useState([]);
  const [imagesDropped, setImagesDropped] = useState(0);
  const [riddlerusLogo, SetriddlerusLogo] = useState("/img/logo.png");
  // Items currently shown inside each bin (binId -> list of { id, url })
  const [itemsInBins, setItemsInBins] = useState({});
  // Conveyor animation when next set of items arrives (right → left)
  const [conveyorArriving, setConveyorArriving] = useState(false);

  const headerSet = useRef(false);
  const pointsRef = useRef(0);
  const totalImagesCount = useRef(0);

  const S3_URL = process.env.REACT_APP_FETCH_S3_UPLOADS || "";
  const S3_BUCKET_URL = (process.env.REACT_APP_S3BUCKET_URL || "").replace(/\/?$/, "/");
  const storedUserData = JSON.parse(sessionStorage.getItem("userData")) || {};

  const isDemoBypass =
    String(storedUserData?.sessionId).toLowerCase() === "demobypass" &&
    String(storedUserData?.organizationId).toLowerCase() === "demobypass";

    console.log("this is s3--",S3_URL);

  // Resolve image URL (mirrors PHP possibleOnS3)
  const resolveUrl = (path) => {
    if (!path) return "";
    const normalized = path.startsWith("uploads") ? path : `${path}`;
    return `${S3_URL}${normalized}`;
  };

  // dvSource: filename length < 25 → uploads folder, else → S3
  const getDvSourceImageUrl = (imgPath) => {
    if (!imgPath) return "";
    const filename = imgPath.includes("/") ? imgPath.split("/").pop() : imgPath;
    if (filename.length < 25) {
      return resolveUrl(imgPath);
    }
    return `${S3_BUCKET_URL}${filename}`;
  };

  useEffect(() => {
    pointsRef.current = points;
  }, [points]);

  // Lock body scroll when game is mounted (prevents mobile portrait scroll)
  useEffect(() => {
    document.body.classList.add("game-active");
    return () => document.body.classList.remove("game-active");
  }, []);

  useEffect(() => {
    if (headerSet.current) return;
    updateHeader({ backButtonRedirect: "/intro" });
    headerSet.current = true;
  }, [updateHeader]);

  // Check already played (skipped when login used fromMobileApp URL for multi-play)
  useEffect(() => {
    if (!storedUserData?.sessionId || isDemoBypass || storedUserData.fromMobileApp)
      return;

    const checkExistingScore = async () => {
      try {
        const response = await getScore({
          userId: storedUserData.userId || storedUserData.userid,
          sessionId: storedUserData.sessionId,
          organizationId: storedUserData.organizationId,
        });

        if (response?.status === "success") {
          const dbTime = response?.data?.time;
          const normalizedTime = String(dbTime).trim();
          const isZeroTime =
            normalizedTime === "00:00" ||
            normalizedTime === "0" ||
            normalizedTime === "00:00:00" ||
            normalizedTime === "0:00";

          if (!isZeroTime) {
            navigate("/thankyou", {
              replace: true,
              state: {
                points: response.data.total_score,
                time: dbTime,
              },
            });
          }
        }
      } catch (error) {
        console.error("Initial score check error:", error);
      }
    };

    checkExistingScore();
  }, []);


  useEffect(() => {

    if (!themeData) return;
  
    const body = document.body;
  
    const updateBackground = () => {
  
      if (!body.classList.contains("common-bg")) return;
  
      const isMobile = window.innerWidth <= 768;
      const isPortrait = window.matchMedia("(orientation: portrait)").matches;
  
      if (isMobile && isPortrait) {
        // ✅ Mobile Portrait
        body.style.backgroundImage = `url(${themeData.background_mob})`;
      } else {
        // ✅ Landscape Mobile + Desktop
        body.style.backgroundImage = `url(${themeData.background_desk})`;
      }
    };
  
    updateBackground(); // run once initially
    window.addEventListener("resize", updateBackground);
  
    SetriddlerusLogo(themeData.logo);
  
    return () => {
      window.removeEventListener("resize", updateBackground);
    };
  
  }, [themeData]);
  // Load theme and build allImages / filteredIcons / first batch
  useEffect(() => {
    const storedTheme = sessionStorage.getItem("themeData");
    if (!storedTheme) {
      navigate("/login");
      return;
    }

    const parsed = JSON.parse(storedTheme);
    setThemeData(parsed);

    const defaultCat = Array.isArray(parsed.default_cat)
      ? parsed.default_cat
      : parsed.default_cat
      ? Object.values(parsed.default_cat)
      : [];
    const catIcons = parsed.cat_icons || {};
    const catItems = parsed.cat_items || {};
    const allIconImage = parsed.all_icon_image || "";

    // Show ALL bins from default_cat; use cat_icons[cat] or fallback to all_icon_image
    const icons = defaultCat.map((cat) => catIcons[cat] || allIconImage);
    setFilteredIcons(icons);

    // Build images preserving defaultCat order for correct bin numbers
    const images = [];
    defaultCat.forEach((cat, binIndex) => {
      const binNumber = binIndex + 1;
      const items = catItems[cat];
      if (!items) return;
      (Array.isArray(items) ? items : [items]).forEach((imgPath) => {
        images.push({
          id: `img-${binNumber}-${images.length}-${Date.now()}`,
          url: getDvSourceImageUrl(imgPath),
          bin: binNumber,
        });
      });
    });

    totalImagesCount.current = images.length;

    const shuffle = (arr) => [...arr].sort(() => Math.random() - 0.5);
    const shuffled = shuffle(images);

    const imgShowCount = Math.min(
      parseInt(parsed.img_count, 10) || 5,
      shuffled.length
    );
    const firstBatch = shuffled.slice(0, imgShowCount);
    const rest = shuffled.slice(imgShowCount);

    setAllImages(shuffled);
    setCurrentBatch(firstBatch);
    setRemainingImages(rest);
  }, [navigate]);

  // Timer count-up
  useEffect(() => {
    if (!themeData || gameComplete) return;
    const timer = setInterval(() => setElapsedTime((p) => p + 1), 1000);
    return () => clearInterval(timer);
  }, [themeData, gameComplete]);

  const formatTime = () => {
    const min = Math.floor(elapsedTime / 60);
    const sec = elapsedTime % 60;
    return `${String(min).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
  };

  const completeGame = async () => {
    if (gameComplete) return;
    setGameComplete(true);

    const currentPoints = pointsRef.current;

    try {
      if (!isDemoBypass) {
        await updateScore({
          userId: storedUserData.userId || storedUserData.userid,
          sessionId: storedUserData.sessionId,
          organizationId: storedUserData.organizationId,
          points: currentPoints,
          time: formatTime(),
          wrongCount: wrongCount,
        });
      }
    } catch (err) {
      console.error("Score update failed:", err);
    }

    Swal.fire({
      icon: "success",
      title: "Game Completed!",
      confirmButtonText: "OK",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/thankyou", {
          state: { points: currentPoints, time: formatTime() },
        });
      }
    });
  };

  const adminRightPoints = parseInt(themeData?.points, 10) || 1;
  const adminWrongPoints = parseInt(themeData?.wrong_points, 10) || 0;
  const imgShowCount = Math.min(
    parseInt(themeData?.img_count, 10) || 5,
    totalImagesCount.current || 5
  );

  const handleDrop = (droppedBinId, item) => {
    if (gameComplete) return;
    const now = Date.now();
    if (lastDropRef.current.id === item.id && now - lastDropRef.current.t < 400) return;
    lastDropRef.current = { id: item.id, t: now };

    const correctBin = item.bin;
    const isCorrect = droppedBinId === correctBin;

    if (isCorrect) {
      // Show dropped item inside the bin (low opacity) only for correct drop
      setItemsInBins((prev) => ({
        ...prev,
        [droppedBinId]: [...(prev[droppedBinId] || []), { id: item.id, url: item.url }],
      }));

      const batchSizeAfterDrop = currentBatch.length - 1;
      const nextDroppedTotal = imagesDropped + 1;

      setPoints((p) => p + adminRightPoints);
      setCurrentBatch((prev) => prev.filter((i) => i.id !== item.id));
      setImagesDropped((d) => d + 1);

      if (isDemoBypass && nextDroppedTotal >= 1) {
        setTimeout(() => {
          Swal.fire({
            icon: "info",
            text: "Thank you for playing. Subscribe to any PLAN to play with your peers.",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(() => {
            window.location.href =
              (process.env.REACT_APP_BASE_URL || "") + "plans";
          });
        }, 500);
        return;
      }

      if (nextDroppedTotal >= totalImagesCount.current) {
        setTimeout(() => completeGame(), 500);
        return;
      }

      if (batchSizeAfterDrop === 0 && remainingImages.length > 0) {
        const nextBatch = remainingImages.slice(0, imgShowCount);
        const nextRemaining = remainingImages.slice(imgShowCount);
        setRemainingImages(nextRemaining);
        setItemsInBins({}); // clear bin preview when loading next batch
        setTimeout(() => {
          setCurrentBatch(nextBatch);
          setConveyorArriving(true); // trigger conveyor right-to-left animation
        }, 800);
        setTimeout(() => setConveyorArriving(false), 1800); // clear after animation
      } else if (batchSizeAfterDrop === 0 && remainingImages.length === 0) {
        setTimeout(() => completeGame(), 500);
      }
    } else {
      setWrongCount((w) => w + 1);
      setPoints((p) => p - adminWrongPoints);
      // Revert: trigger shake animation so item visually "stays" on platform
      setWrongDropItemId(item.id);
      setTimeout(() => setWrongDropItemId(null), 500);
    }
  };

  // Drag state for native HTML5 drag (and jQuery UI visual state)
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOverBin, setDragOverBin] = useState(null);
  const [wrongDropItemId, setWrongDropItemId] = useState(null);

  const gameContainerRef = useRef(null);
  const handleDropRef = useRef(handleDrop);
  handleDropRef.current = handleDrop;
  const lastDropRef = useRef({ id: null, t: 0 });

  // jQuery UI + Touch Punch for drag-and-drop (works on mobile portrait)
  useEffect(() => {
    if (!themeData || !gameContainerRef.current) return;
    const $ = window.jQuery || window.$;
    if (!$ || typeof $.fn.draggable !== "function" || typeof $.fn.droppable !== "function") return;

    const $container = $(gameContainerRef.current);

    // Destroy previous instances only if they were already initialized
    $container.find(".draggable-item").each(function () {
      if ($(this).data("ui-draggable")) $(this).draggable("destroy");
    });
    $container.find(".bin-dest").each(function () {
      if ($(this).data("ui-droppable")) $(this).droppable("destroy");
    });

    const $items = $container.find(".draggable-item");
    $items.each(function (i) {
      $(this).data("binTossItem", currentBatch[i]);
    });

    $container.find(".draggable-item").draggable({
      revert: true,
      cursor: "move",
      // containment: "window",
      zIndex: 1000,
      start: function () {
        $(this).addClass("dragging");
        $container.addClass("dragging-active");
        $container.find(".dvSource").addClass("dragging-active");
      },
      stop: function () {
        $(this).removeClass("dragging");
        $container.removeClass("dragging-active");
        $container.find(".dvSource").removeClass("dragging-active");
        setDragOverBin(null);
      },
    });

    $container.find(".bin-dest").droppable({
      accept: ".draggable-item",
      over: function () {
        const id = $(this).attr("id");
        if (id) setDragOverBin(parseInt(id.replace("dvDest_", ""), 10));
      },
      out: function () {
        setDragOverBin(null);
      },
      drop: function (event, ui) {
        const item = $(ui.draggable).data("binTossItem");
        const binId = parseInt($(this).attr("id").replace("dvDest_", ""), 10);
        if (item) handleDropRef.current(binId, item);
      },
    });

    return function cleanup() {
      $container.removeClass("dragging-active");
      $container.find(".dvSource").removeClass("dragging-active");
      $container.find(".draggable-item").each(function () {
        if ($(this).data("ui-draggable")) $(this).draggable("destroy");
      });
      $container.find(".bin-dest").each(function () {
        if ($(this).data("ui-droppable")) $(this).droppable("destroy");
      });
    };
  }, [themeData, currentBatch, filteredIcons]);

  // Native handlers kept for desktop if jQuery UI not loaded (fallback)
  const handleDragStart = (e, item) => {
    setDraggedItem(item);
    e.dataTransfer.setData("text/plain", item.id);
    e.dataTransfer.effectAllowed = "move";
    const el = e.currentTarget;
    if (el) el.classList.add("dragging");
    const container = gameContainerRef.current;
    const dvSource = container?.querySelector(".dvSource");
    if (container) container.classList.add("dragging-active");
    if (dvSource) dvSource.classList.add("dragging-active");
  };

  const handleDragEnd = (e) => {
    const el = e.currentTarget;
    if (el) el.classList.remove("dragging");
    const container = gameContainerRef.current;
    const dvSource = container?.querySelector(".dvSource");
    if (container) container.classList.remove("dragging-active");
    if (dvSource) dvSource.classList.remove("dragging-active");
    setDraggedItem(null);
    setDragOverBin(null);
  };

  const handleDragOver = (e, binId) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    setDragOverBin(binId);
  };

  const handleDragLeave = () => {
    setDragOverBin(null);
  };

  const handleDropOnBin = (e, binId) => {
    e.preventDefault();
    setDragOverBin(null);
    const id = e.dataTransfer.getData("text/plain");
    if (!id || !draggedItem || draggedItem.id !== id) return;
    handleDrop(binId, draggedItem);
    setDraggedItem(null);
  };

  if (!themeData) return null;

  const totalBins = filteredIcons.length;
  const bgUrl = themeData.background_desk || themeData.background_mob || "";
  const bgResolved = bgUrl.startsWith("http") ? bgUrl : resolveUrl(bgUrl);
  const diceImage = getDvSourceImageUrl(themeData.dice_image);
  const mobileBg = themeData.background_mob
    ? (themeData.background_mob.startsWith("http")
        ? themeData.background_mob
        : resolveUrl(themeData.background_mob))
    : bgResolved;

  return (
    <>
      {/* <div className="rotate-overlay">
        <div className="rotate-message">
          Please rotate your device for the best experience
        </div>
      </div> */}

      <div
        ref={gameContainerRef}
        className="game-container bin-toss-game-touch"
      >
        <div className="bin-toss-top">
          <div
            className="timer-back"
            style={{
              backgroundColor: themeData?.button_color,
              color: themeData?.button_Textcolor ?? themeData?.landing_page_title_color,
            }}
          >
            Time: <span id="timer">{formatTime()}</span>
          </div>

          <div className="point-skip">
            <div
              className="pointBox"
              style={{
                backgroundColor: themeData?.button_color,
                color: themeData?.button_Textcolor ?? themeData?.landing_page_title_color,
              }}
            >
              Points: <span id="score">{points}</span>
            </div>
            <div
              className="wrongClass"
              style={{
                backgroundColor: themeData?.button_color,
                color: themeData?.button_Textcolor ?? themeData?.landing_page_title_color,
              }}
            >
              Wrong count: <span id="wrongcount">{wrongCount}</span>
            </div>
          </div>
        </div>

        <div className="bin-toss-title-row">
          <h3
            className="log-title bin-toss-instruction"
            style={{ color: themeData?.landing_page_title_color || "#1a1a1a" }}
          >
            {themeData?.landing_page_title}
          </h3>
        </div>

        <div className="maincontainer">
          <div className="main-box auto">
            {filteredIcons.map((icon, index) => {
              const binId = index + 1;
              const iconUrl = getDvSourceImageUrl(icon);
              return (
                <div
                  key={`bin-${binId}`}
                  className={`bin-dest ${dragOverBin === binId ? "drag-over" : ""}`}
                  id={`dvDest_${binId}`}
                  style={{ backgroundImage: `url('${iconUrl}')` }}
                  onDragOver={(e) => handleDragOver(e, binId)}
                  onDragLeave={handleDragLeave}
                  onDrop={(e) => handleDropOnBin(e, binId)}
                >
                  <div className="bin-items-inside">
                    {(itemsInBins[binId] || []).map((dropped) => (
                      <img
                        key={dropped.id}
                        src={dropped.url}
                        alt=""
                        className="bin-item-inside"
                      />
                    ))}
                  </div>
                  <div className="bin-check" id={`check_${binId}`} />
                </div>
              );
            })}
          </div>
        </div>

        <div
          className={`downpallete ${!diceImage ? "wooden-platform" : ""} ${conveyorArriving ? "conveyor-arrive" : ""}`}
          style={{
            backgroundColor: themeData?.belt_color || "#c4a574",
            backgroundImage: diceImage ? `url(${diceImage})` : undefined,
          }}
        >
          <div id="dvSource" className={`dvSource ${conveyorArriving ? "conveyor-arrive" : ""}`}>
            {currentBatch.map((imgObj) => (
              <div
                key={imgObj.id}
                className={`item-box draggable-item ${wrongDropItemId === imgObj.id ? "revert-wrong" : ""}`}
                data-item-id={imgObj.id}
                draggable
                onDragStart={(e) => handleDragStart(e, imgObj)}
                onDragEnd={handleDragEnd}
              >
                <img
                  src={imgObj.url}
                  alt=""
                  className="item_img img-fluid"
                  draggable={false}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .game-container.bin-toss-bg {
            background-image: url(${mobileBg});
          }
        }
      `}</style>
    </>
  );
}

export default Game;
